import apiClient from "utils/apiClient";

const TASKS_BASE = "/olitask-service/api/v1/tasks";
const CARE_TASKS_BASE = "/olitask-service/api/v1/caretasks";
const TRAVO_TASKS_BASE = "/olitask-service/api/v1/travotasks";
const MOBILE_CLIENT_APP = "OLITASK_MOBILE_UI";
const ACTOR_ID_HEADER = "actor-id";

const unwrap = (response) => response?.data;

export const createTaskRequest = (payload, taskType = "GENERAL", config = {}) => {
  const normalizedType = String(taskType || payload?.taskType || "GENERAL").toUpperCase();
  const endpoint =
    normalizedType === "CARE" || normalizedType === "CARETASK"
      ? CARE_TASKS_BASE
      : normalizedType === "TRAVO" || normalizedType === "TRAVOTASK"
        ? TRAVO_TASKS_BASE
        : TASKS_BASE;

  return apiClient
    .post(endpoint, payload, {
      ...config,
      headers: {
        "O-CLIENT-APP": MOBILE_CLIENT_APP,
        ...(config.headers || {}),
      },
    })
    .then(unwrap);
};

export const listCareTaskRequests = (params = {}) =>
  apiClient.get(CARE_TASKS_BASE, { params }).then(unwrap);

export const listRequesterTasks = (params = {}) =>
  apiClient
    .get(`${TASKS_BASE}/requester-tasks`, {
      params,
      headers: {
        "O-CLIENT-APP": MOBILE_CLIENT_APP,
      },
    })
    .then(unwrap);

const mobileHeaders = (actorId) => ({
  "O-CLIENT-APP": MOBILE_CLIENT_APP,
  ...(actorId ? { [ACTOR_ID_HEADER]: actorId } : {}),
});

export const getTaskDetails = (taskId, config = {}) =>
  apiClient
    .get(`${TASKS_BASE}/${taskId}`, {
      ...config,
      headers: {
        ...mobileHeaders(config?.actorId),
        ...(config?.headers || {}),
      },
    })
    .then(unwrap);

export const getCareTaskDetails = (taskId, config = {}) =>
  apiClient
    .get(`${CARE_TASKS_BASE}/task/${taskId}`, {
      ...config,
      headers: {
        ...mobileHeaders(config?.actorId),
        ...(config?.headers || {}),
      },
    })
    .then(unwrap);

export const navigateTask = (taskId, pingLocation, actorId) =>
  apiClient
    .put(`${TASKS_BASE}/${taskId}/navigate`, pingLocation || {}, {
      headers: mobileHeaders(actorId),
    })
    .then(unwrap);

export const markTaskArrived = (taskId, pingLocation, actorId) =>
  apiClient
    .put(`${TASKS_BASE}/${taskId}/arrived`, pingLocation || {}, {
      headers: mobileHeaders(actorId),
    })
    .then(unwrap);

export const startTask = (taskId, pingLocation, actorId) =>
  apiClient
    .put(`${TASKS_BASE}/${taskId}/start`, pingLocation || {}, {
      headers: mobileHeaders(actorId),
    })
    .then(unwrap);

export const completeTask = (taskId, pingLocation, actorId) =>
  apiClient
    .put(`${TASKS_BASE}/${taskId}/completed`, pingLocation || {}, {
      headers: mobileHeaders(actorId),
    })
    .then(unwrap);

export const cancelTask = (taskId, payload, actorId) =>
  apiClient
    .put(`${TASKS_BASE}/${taskId}/cancel`, payload || {}, {
      headers: mobileHeaders(actorId),
    })
    .then(unwrap);

export const tipTask = (taskId, payload, actorId) =>
  apiClient
    .post(`${TASKS_BASE}/${taskId}/tip`, payload || {}, {
      headers: mobileHeaders(actorId),
    })
    .then(unwrap);

export const reviewTask = (payload, actorId) =>
  apiClient
    .post("/olitask-service/api/v1/task-reviews", payload || {}, {
      headers: mobileHeaders(actorId),
    })
    .then(unwrap);

const olitaskTaskService = {
  create: createTaskRequest,
  careTasks: {
    list: listCareTaskRequests,
    details: getCareTaskDetails,
  },
  requesterTasks: {
    list: listRequesterTasks,
  },
  details: getTaskDetails,
  actions: {
    navigate: navigateTask,
    arrived: markTaskArrived,
    start: startTask,
    complete: completeTask,
    cancel: cancelTask,
    tip: tipTask,
    review: reviewTask,
  },
};

export default olitaskTaskService;
